// mobile
if (window.innerWidth < 750) {
    document.addEventListener("click", function (e) {
    const menuItem = e.target.closest(
      ".menu-drawer__menu--childlist .menu-drawer__menu-item"
    );

    if (!menuItem) return;

    const href = menuItem.getAttribute("href");
    if (!href || !href.includes("/collections/")) return;

    e.preventDefault();

    const collectionName = href
      .split("/collections/")[1]
      .split("?")[0];

    // Toggle collection containers
    document
      .querySelectorAll(".mega_menu_single_collection_container")
      .forEach(container => {
        container.classList.toggle(
          "active",
          container.dataset.collection === collectionName
        );
      });

    // Toggle active menu item
    document
      .querySelectorAll(
        ".menu-drawer__menu--childlist .menu-drawer__menu-item"
      )
      .forEach(item => item.classList.remove("active"));

    menuItem.classList.add("active");

    const activeItem = document.querySelector(
      ".menu-drawer__menu--childlist .menu-drawer__menu-item.active"
    );

    if (activeItem) {
      activeItem.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }

  });

  //   first collection - active
  const observer = new MutationObserver(() => {
    const firstItem = document.querySelector(
      ".menu-drawer__menu--childlist .menu-drawer__menu-item"
    );

    if (firstItem && !firstItem.classList.contains("active")) {
      firstItem.click();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// desktop
if (window.innerWidth > 749) {
  document.querySelectorAll(".mega-menu__link").forEach(link => {
    link.addEventListener("click", function (e) {
      const href = this.getAttribute("href");

      if (!href || !href.includes("/collections/")) return;

      e.preventDefault();

      const collection_name = href.split("/collections/")[1].split("?")[0];

      document.querySelectorAll(".mega_menu_single_collection_container").forEach(container => {
        container.classList.toggle(
          "active",
          container.dataset.collection === collection_name
        );
      });

      document.querySelectorAll(".mega-menu__link").forEach(l => l.classList.remove("active"));
      this.classList.add("active");

    });
  });

  //   first collection - active
  const observerDesktop = new MutationObserver(() => {
    const firstItemDesktop = document.querySelector(
      ".mega-menu__link"
    );

    if (firstItemDesktop && !firstItemDesktop.classList.contains("active")) {
      firstItemDesktop.click();
    }
  });

  observerDesktop.observe(document.body, {
    childList: true,
    subtree: true
  });
}


// set consistent product grid height 
function setMaxProductGridHeight() {
  const containers = document.querySelectorAll(".mega_menu_single_collection_container");
  let maxHeight = 0;

  containers.forEach(container => {
    const grid = container.querySelector(".mega_menu_single_collection_product_grid");
    if (!grid) return;

    // Temporarily show container off-screen to measure
    const originalDisplay = container.style.display;
    container.style.display = "block";
    container.style.position = "absolute";
    container.style.visibility = "hidden";

    grid.querySelectorAll(".product-card").forEach(card => {
      const h = card.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });

    // Revert container styles
    container.style.display = originalDisplay;
    container.style.position = "";
    container.style.visibility = "";
  });

  // Apply min-height to all grids
  containers.forEach(container => {
    const grid = container.querySelector(".mega_menu_single_collection_product_grid");
    if (grid) {
      grid.style.minHeight = maxHeight + "px";
    }
  });
}

// Wait for page + any mega menu JS to fully initialize
window.addEventListener("load", () => {
  setMaxProductGridHeight();
});
window.addEventListener("resize", () => {
  setMaxProductGridHeight();
});

// Optional: reapply if menu changes on click
document.querySelectorAll(".mega-menu__link").forEach(link => {
  link.addEventListener("click", () => {
    setTimeout(setMaxProductGridHeight, 100); // wait for active class toggle
  });
});
